import types from '../constants/types'

export const shareAction = {
  share({ dispatch, commit }, param) {
    commit(types.SHARE_STATUS, param)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/share.js